import { css } from '@emotion/core';
import { API } from "aws-amplify";
import axios from 'axios';
import 'containers/common/Detail.css';
import Moment from "moment";
import React, { Component } from "react";
import { Accordion, Button, Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import Select from 'react-select';
import { PacmanLoader } from 'react-spinners';
import HybridProofingCategory from './HybridProofingCategory';


const CancelToken = axios.CancelToken;
const source = CancelToken.source();


export default class HybridProofingDetail extends Component {
    constructor(props) {
        super(props);

        const isSLM = props.location.pathname.startsWith('/slm');

        this.state = {
            isSLM: isSLM,

            isLoading: null,
            queueTypes: [],
            cityscopeOptions: [],
            searchRun: false,

            // Filters section
            queueType: null,
            queueTypeResearchTeam: (isSLM) ? 'SLM' : 'Cityscope',
            selectedCityscope: null,
            queueAction: null,
            userActioned: null,
            dateActionedFrom: null,
            dateActionedTo: null,
            userClosed: null,
            dateClosedFrom: null,
            dateClosedTo: null,

            itemCategories: [],
        };
    }

    async componentDidMount() {
        try {
            this.setState({ isLoading: true });   

            const cityscopeOptions = await this.getCityscopes();

            if (cityscopeOptions) {     
                this.setState(state => ({ cityscopeOptions }));
            }

            const queueTypes = await this.getQueueTypes();

            if (queueTypes) {
                this.setState(state => ({ queueTypes }));
                this.setState({ queueTypeDropdown: queueTypes.map(t => ({ value: t.queue_type_id, label: t.queue_type })) });
            }
            
            document.title = `Ad-hoc Proofing Queues (${this.state.isSLM ? 'SLM' : 'Cityscope'})`;

            this.setState({ isLoading: false });   
        } catch (e) {
            alert(e);
        }
    }

    componentWillUnmount() {
        source.cancel();
    }

    async getCityscopes() {
        return API.get("colin", `/cityscopes/dropdown`, { 'cancelToken': source.token });                
    }

    async getQueueTypes() {
        const filter = {
            research_team: this.state.queueTypeResearchTeam
        }

        return API.get('colin', '/proofing/queue_types', { 'queryStringParameters': filter }, { 'cancelToken': source.token });
    }

    handleChange = event => {
        
        this.setState({
            [event.target.id]: event.target.value
        });
        
    }

    handleQueueTypeChange = async (queueType) => {
        this.setState(state => ({ queueType }));
    }

    handleCityscopeChange = async (selectedCityscope) => {
        if (!selectedCityscope || selectedCityscope.length === 0) {
            this.setState(state => ({ selectedCityscope: null }));
            return;
        }

        this.setState(state => ({ selectedCityscope }));
    }

    handleDateChange(date, name) {
        if (date) {
            this.setState({
                [name]: new Date(date)
            });
        }
        else {
            this.setState({
                [name]: null
            });
        }
        this.setState({ modified: true });
    }

    handleSearch = async () => {
        this.setState({ isLoading: true });

        const filter = {
            queue_type_id: (this.state.queueType !== null) ? this.state.queueType.value : null,
            queue_type_research_team: this.state.queueTypeResearchTeam,
            cityscope: (this.state.selectedCityscope || []).map(c => c.value).join(','),
            action: this.state.queueAction,
            user_actioned: this.state.userActioned,
            date_actioned_from: (this.state.dateActionedFrom !== null) ? this.state.dateActionedFrom.toISOString() : null,
            date_actioned_to: (this.state.dateActionedTo !== null) ? this.state.dateActionedTo.toISOString() : null,
            user_closed: this.state.userClosed,
            date_closed_from: (this.state.dateClosedFrom !== null) ? this.state.dateClosedFrom.toISOString() : null,
            date_closed_to: (this.state.dateClosedTo !== null) ? this.state.dateClosedTo.toISOString() : null
        };
        const itemCategoriesResponse = await API.get("colin", `/proofing/queues`, { 'queryStringParameters': filter,'cancelToken': source.token });

        this.setState({ isLoading: false, itemCategories: [] });

        // Should be an empty list at the very least
        if (itemCategoriesResponse === null) {
            alert('Unable to fetch results.');
            return;
        }

        const groupBy = function(xs, key) {
            return Object.entries(xs.reduce(function(rv, x) {
                x.selected = true;
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {})).map(([queue_type_id, queues]) => {
                const queueType = this.state.queueTypes.find(t => t.queue_type_id == queue_type_id);

                // Can only happen if there's de-sync between available queues and available queue_types
                console.assert(queueType !== null, 'No matching queueType for queues:', queues);

                return {
                    id: queue_type_id,
                    name: (queueType) ? queueType.queue_type : null,
                    description: (queueType) ? queueType.description : null,
                    items: queues
                }
            });
        };
        const itemCategories = groupBy.bind(this)(itemCategoriesResponse, 'queue_type_id');

        this.setState({ itemCategories });
        this.setState({ searchRun: true })
    };

    render() {
        return (
            <div className="Proofing">
                {this.state.isLoading &&
                <div className="outer-div">
                    <div className='sweet-loading inner-div' >
                        <PacmanLoader
                            css={css`
                            display: block;
                            margin: 0 auto;
                            border-color: red`}
                            sizeUnit={"px"}
                            size={20}
                            color={'#e03c31'}
                            loading={this.state.isLoading}
                        />
                    </div>
                </div>
                }
               
                {this.state.cityscopeOptions && this.props.isAuthenticated && !this.state.isLoading &&
                <div className="ProofingForm">
                    <Row >
                        <Col sm={12} md={12} lg={12}><h6>Ad-hoc Proofing Queues ({this.state.isSLM ? 'SLM' : 'Cityscope'})</h6></Col>
                    </Row>
                    <Form className="mb-4">
                        <Row>
                            <Col lg={2}>
                                <Form.Group controlId="queueType" > 
                                    <Select
                                        value={this.state.queueType}
                                        options={this.state.queueTypeDropdown}
                                        placeholder="Queue Type"
                                        onChange={this.handleQueueTypeChange}
                                    />
                                </Form.Group>
                            </Col>

                            {!this.state.isSLM &&
                            <Col lg={2}>
                                <Form.Group controlId="cityscope" > 
                                    <Select
                                        value={this.state.selectedCityscope}
                                        onChange={this.handleCityscopeChange}
                                        options={this.state.cityscopeOptions}
                                        placeholder="Cityscope"
                                        isMulti
                                    />
                                </Form.Group>
                            </Col>
                            }

                            <Col lg={2}>
                                <Form.Group controlId="queueAction" > 
                                    <Form.Control
                                        value={this.state.queueAction}
                                        placeholder="Queue Action"
                                        componentClass="input"
                                        type="text"
                                        onChange={this.handleChange}
                                    />
                                </Form.Group>
                            </Col>

                        </Row>

                        <Row>
                            <Col lg={2}>
                                <Form.Group controlId="userActioned" > 
                                    <Form.Control
                                        value={this.state.userActioned}
                                        placeholder="User that Actioned"
                                        componentClass="input"
                                        type="text"
                                        onChange={this.handleChange}
                                    />
                                </Form.Group>
                            </Col>

                            <Col lg={2}>
                                <Row>
                                    <Col className="pr-0">
                                        <Form.Group controlId="dateActionedFrom" > 
                                            <DatePicker
                                                selected={this.state.dateActionedFrom}
                                                onChange={e => this.handleDateChange(e, "dateActionedFrom")}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                placeholderText="Date Actioned from"
                                                isClearable
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className="pl-0">
                                        <Form.Group controlId="dateActionedTo" className="float-right"> 
                                            <DatePicker
                                                selected={this.state.dateActionedTo}
                                                onChange={e => this.handleDateChange(e, "dateActionedTo")}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                placeholderText="Date Actioned to"
                                                isClearable
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>

                            <Col lg={2}>
                                <Form.Group controlId="userClosed" > 
                                    <Form.Control
                                        value={this.state.userClosed}
                                        placeholder="User that Closed"
                                        componentClass="input"
                                        type="text"
                                        onChange={this.handleChange}
                                    />
                                </Form.Group>
                                
                            </Col>

                            <Col lg={2}>
                                <Row>
                                    <Col className="pr-0">
                                        <Form.Group controlId="dateClosedFrom" > 
                                            <DatePicker
                                                selected={this.state.dateClosedFrom}
                                                onChange={e => this.handleDateChange(e, "dateClosedFrom")}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                placeholderText="Date Closed from"
                                                isClearable
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className="pl-0">
                                        <Form.Group controlId="dateClosedTo" className="float-right"> 
                                            <DatePicker
                                                selected={this.state.dateClosedTo}
                                                onChange={e => this.handleDateChange(e, "dateClosedTo")}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                placeholderText="Date Closed to"
                                                isClearable
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>

                            <Col lg={4}>
                                <Button variant="primary" onClick={this.handleSearch}>Search</Button><br />
                            </Col>
                        </Row>
                    </Form>
                    <div className="proofResults">
                        { this.state.searchRun && this.state.itemCategories.length === 0 && <h4 class="text-center">No results to display.</h4> }
                        <Accordion defaultActiveKey="0">
                            {
                                this.state.itemCategories.map(c => {
                                    return (
                                        <HybridProofingCategory key={c.id}
                                            id={c.id}
                                            name={c.name}
                                            description={c.description}
                                            items={c.items}
                                            user={this.props.user}
                                        ></HybridProofingCategory>
                                    );
                                })
                            }
                        </Accordion>
                    </div>
                </div>
                }
            </div>
        );
    }
}